
import { Product } from "@/types/product";
import { FEATURED_PRODUCTS } from "@/data/products";

export type SortOption = "name-asc" | "name-desc" | "price-asc" | "price-desc";

export const recentSearches = [
  "Paracetamol",
  "Vitamin C",
  "Antibiotics",
  "Blood pressure",
  "Diabetes medication"
];

export function getFilteredProducts(
  searchQuery: string,
  category: string | null,
  prescription: boolean | null,
  sortBy: SortOption
): Product[] {
  let filtered = [...FEATURED_PRODUCTS];
  
  // Apply search filter
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    filtered = filtered.filter(product => 
      product.title.toLowerCase().includes(query) ||
      product.category.toLowerCase().includes(query)
    );
  }
  
  // Apply category filter
  if (category) {
    filtered = filtered.filter(product => product.category === category);
  }
  
  // Apply prescription filter
  if (prescription !== null) {
    filtered = filtered.filter(product => product.prescription === prescription);
  }
  
  // Apply sorting
  switch (sortBy) {
    case "name-asc":
      filtered.sort((a, b) => a.title.localeCompare(b.title));
      break;
    case "name-desc":
      filtered.sort((a, b) => b.title.localeCompare(a.title));
      break;
    case "price-asc":
      filtered.sort((a, b) => a.price - b.price);
      break;
    case "price-desc":
      filtered.sort((a, b) => b.price - a.price);
      break;
  }
  
  return filtered;
}

export function getPrescriptionCount(): number {
  return FEATURED_PRODUCTS.filter(product => product.prescription).length;
}

export function getOtcCount(): number {
  return FEATURED_PRODUCTS.filter(product => !product.prescription).length;
}
